import React, { useState, useEffect } from "react";
import DataFetchHookCB from "../../helper/DataFetchHookCB";
import StatusText from "../../helper/Table/StatusText";
import PermissionsRequired from "../../helper/PermissionsRequired";
import CreateMerchant from "./CreateMerchant";
//import MerchantModal from "./Merchant";
import moment from "moment";
import { Table, PageHeader, Button, Card, Form, Row, Col, Select, Input } from "antd";
import { SearchOutlined, FileSearchOutlined } from "@ant-design/icons";
import { CBM_URL } from "../../config/config";
import CustomPaginationV2 from "../../helper/Table/CustomPaginationV2";
import SortOrder from "../../helper/Table/SortOrder";
import AssociationsChecker from "../../helper/AssociationsChecker";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

const { Option } = Select;

const DATA_URL = CBM_URL + "/api/v1/merchants";

const ChargebackMerchantList = (props) => {
    const [{ data, totalResult, requestData, isLoading, isError, errorMsg }, doFetch, setRequestData, setMethod, setToken] = DataFetchHookCB(DATA_URL,"POST",Cookies.get("cbm_token"),{page:1,size:20,order:'ASC',orderVar:'name'}); // eslint-disable-line
    const [formData, setFormData] = useState();   
    const [sortedInfo, setSortedInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const { t } = props;

    const initFormData = {
        keyword: "",
        field: "name",
        //  order: null,
        
    };

    const [form] = Form.useForm();

    useEffect(() => {     
        if(isLoading === false)
        {             
            if(errorMsg)
            {
                Swal.fire({
                    icon: "error",
                    title: errorMsg,
                    showConfirmButton: true,
                });
            }
            formValInit();
        }
    }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

   

    const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
        setSortedInfo(sorter);
    };

    const formValInit = async () => {
        setFormData(initFormData);
        form.setFieldsValue(initFormData);
       
    };

    const clearAll = () => {
        setFormData(initFormData);
        setRequestData({ ...requestData, ...initFormData, page: 1 });
        form.setFieldsValue(initFormData);
    };

    const formValChange = (chgV, allV) => {
        setFormData(allV);
    };

    const onFinish = () => {
        let searchData = {};
        if (formData) {
            searchData = {
                field: formData.field,
                keyword: formData.keyword ? formData.keyword.trim() : null,
                // order: formData.order,
            };
        }
        // Reset Page Index to 1
        setCurrentPage(1);
        setRequestData({ ...requestData, ...searchData, page: 1 });
    };

    const AdvancedSearchForm = () => (
        <div className="search-wrap">
            <Card title={t("tables.actions.search")} size="small">
                <Form form={form} size="large" name="advanced_search" className="ant-advanced-search-form" onValuesChange={formValChange} onFinish={onFinish}>
                    <Row gutter={[16, 16]}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }} xl={{ span: 5 }}>
                            <Form.Item name="field">
                                <Select style={{ width: "100%" }} placeholder={t("tables.fields.field")}>
                                    <Option value="name">{t("tables.fields.name")}</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12}} lg={{ span: 6 }} xl={{ span: 8 }}>
                            <Form.Item name="keyword">
                                <Input placeholder={t("tables.fields.keyword")} />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6, offset: 12 }} lg={{ span: 6 }} xl={{ span: 3, offset: 4 }}>
                            <Form.Item>
                                <Button type="secondary" onClick={() => clearAll()} block>
                                    {t("tables.actions.clear_all")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block>
                                    <SearchOutlined /> {t("tables.actions.search")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );

    const columns = [
        {
            dataIndex: "name",
            key: "name",
            title: t("tables.fields.merchantname"),
            sorter: {
                compare: (a, b) => a.name.localeCompare(b.name),
                multiple: 1,
            },
            sortOrder: SortOrder(sortedInfo, "name"),
           
        },
        {
            dataIndex: "alerts",
            key: "alerts",
            title: t("tables.fields.alerts"),
            width: 250,
            render: (alerts) => (alerts === 1?'Yes':'No'),
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.alerts-b.alerts,
            },
            sortOrder: SortOrder(sortedInfo, "alerts"),
        },
        {
            dataIndex: "transactionprocessing",
            key: "transactionprocessing",
            title: t("tables.fields.transactionprocessing"),
            width: 200,
            render: (transactionprocessing) => (transactionprocessing === 1?'Yes':'No'),
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.transactionprocessing-b.transactionprocessing,
            },
            sortOrder: SortOrder(sortedInfo, "transactionprocessing"),
        },
        {
            dataIndex: "isactive",
            key: "isactive",
            title: t("tables.fields.status"),
            width: 200,
            render: (isactive) => StatusText(isactive === 1?'ACTIVE':'INACTIVE'),
            ellipsis: true,
            sorter: {
                compare: (a, b) => a.isactive-b.isactive,
            },
            sortOrder: SortOrder(sortedInfo, "isactive"),
        },
        {
            dataIndex: "action",
            title: t("tables.fields.action"),
            align: "left",
            fixed: "right",
            width: 120,
         
            render: (text, record) => (
                <Button type="link" size="small" href={`/cbm_merchant/${record.mid}`} style={{ marginLeft: "auto" }}>
                    <FileSearchOutlined style={{ color: "rgba(0, 0, 0, 0.85)", fontSize: "18px" }} />
                </Button>
            ),
        },
    ];

    const fetchMerchants = () => doFetch(DATA_URL + `?` + moment().unix());

    const getDataSource = (datalist) => (datalist && Array.isArray(datalist) ? datalist : []);

    const getHeaderTable = () => (
        PermissionsRequired("SYSADMIN")?
        <div className="custom-table--header d-flex justify-content-between align-items-center">
            <h3 className="table-title">{t("contents.chargebacks.merchants")}</h3>
          <CreateMerchant t={t} fetchMerchants={fetchMerchants} />
        </div> :''
    );

    return PermissionsRequired("SYSADMIN") || AssociationsChecker("CBM") ? (
        <div>
            <PageHeader title={t("contents.chargebacks.merchants")}></PageHeader>
            {AdvancedSearchForm()}
     
            <Table
                size="small"
                loading={isLoading}
                columns={columns}
                title={() => getHeaderTable()}
                rowKey="mid"
                className="table-v3 custom-pagination"
                dataSource={getDataSource(data.datalist)}
                onChange={handleChange}
                pagination={CustomPaginationV2({ totalResult, currentPage, requestData, setRequestData, setCurrentPage })}
            />
        </div>
    ) : null;
};

export default ChargebackMerchantList;
